<div class="terms-conditions-popup">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      Terms And Conditions - Thorough Repository Pty Ltd
    </h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="closePopup()"
    ></button>
  </div>

  <div class="modal-body">
    <div
      name="termly-embed"
      data-id="16f9f0a0-a798-4535-8899-b0922e5bb57b"
    ></div>
  </div>
</div>
